import React from 'react';
import { ItemSkeleton } from '../item-skeleton';
import css from './item-skeleton-list.scss';
const ITEMS_COUNT = 3;
export const ItemSkeletonList = () => /*#__PURE__*/React.createElement("div", {
  className: css.wrapper
}, /*#__PURE__*/React.createElement("div", null, new Array(ITEMS_COUNT).fill( /*#__PURE__*/React.createElement(ItemSkeleton, null))), /*#__PURE__*/React.createElement("button", {
  className: css.button
}));